import { en } from "../en/common";

export const ptBR: typeof en = {
  app: {
    error: {
      title: "Não foi possível carregar a página",
      description:
        "Uma nova versão pode estar disponível. Recarregue a página para continuar.",
      reload: "Recarregar página",
    },
  },
  actions: {
    cancel: "Cancelar",
    create: "Criar",
    update: "Atualizar",
    finalize: "Finalizar",
    close: "Fechar",
    archive: "Arquivar",
    delete: "Excluir",
    edit: "Editar",
    resolve: "Resolver",
    save: "Salvar",
    new: "Novo",
  },
  common: {
    name: "Nome",
    personal: "Pessoal",
    description: "Descrição",
    emptyDescription: "Sem descrição",
    optional: "Opcional",
    organization: "Organização",
    template: "Template",
    templates: "Templates",
    organizations: "Organizações",
    general: "Geral",
    configuration: "Configuração",
    orderBy: "Ordenar:",
    changeStatus: "Mudar status",
    image: "Imagem",
    images: "Imagens",
    attachments: "Anexos",
    unavailableImage: "Imagem indisponível",
    unset: "Não informado",
    history: "Histórico",
    createdAt: "Criado em",
    createdBy: "Criado por",
    updatedAt: "Atualizado em",
    updatedBy: "Atualizado por",
    viewAllHistory: "Ver histórico completo",
    addTags: "Adicione etiquetas",
    pickDate: "Selecione uma data",
    imageDropArea: "Solte imagens aqui ou clique para enviar",
    tags: "Tags",
  },
  images: {
    selectImage: "Selecione uma imagem",
  },
  appbar: {
    searchText: "Procure qualquer coisa...",
    accountMenu: {
      account: "Minha conta",
      theme: "Tema",
      language: "Idioma",
      signOut: "Sair",
    },
  },
  projects: {
    title: "Projetos",
    description: "Gerencie e crie seus projetos",
    create: "Criar projeto",
    form: {
      title: "Crie e administre apontamentos e mais com os Projetos Floorbit.",
      namePlaceholder: "Adicione um nome ao seu projeto",
      descriptionPlaceholder: "Você também pode adicionar uma descrição",
      projectImage: "Imagem do projeto",
      templateDescription:
        "Use um template para criar um projeto pré configurado.",
      personalProjectDescription: "Apenas você verá esse projeto.",
      organizationProjectDescription: "Todos da organização verão o projeto.",
      selectTemplate: "Selecione um template",
    },
    tabs: {
      activity: "Atividade",
      issues: "Apontamentos",
      board: "Quadro",
      files: "Arquivos",
      models: "Modelos",
      statistics: "Estatísticas",
      people: "Pessoas",
      team: "Equipe",
      settings: "Configurações",
    },
    empty: {
      title: "Sem projetos!",
      description: "Atualmente você não possui nenhum projeto.",
      create: "Crie seu primeiro projeto",
    },
    storeys: {
      zone: "Zona",
      tower: "Torre",
      defaultZoneName: "Torre",
      zoneTower: "zona/torre",
      storey: "Pavimento",
      area: "Local",
    },
    statistics: {
      description: "Acompanhe os principais indicadores deste projeto.",
      issuesByStatus: "Apontamentos por status",
      issuesByStatusDescription:
        "Distribuição de todos os apontamentos publicados neste projeto.",
      totalIssues: "Total de apontamentos",
    },
    models: {
      title: "Modelos IFC",
      description:
        "Envie e acompanhe o processamento dos modelos IFC deste projeto.",
      add: "Adicionar modelo IFC",
      addFirst: "Adicionar seu primeiro modelo IFC",
      dropActiveTitle: "Solte para enviar o modelo IFC",
      dropActiveDescription: "O processamento começará após o envio.",
      uploading: "Enviando {{progress}}%",
      uploadStarted: "IFC enviado. O processamento da geometria foi iniciado.",
      uploadFailed: "Não foi possível enviar o modelo IFC.",
      invalidFile: "Selecione um arquivo .ifc válido.",
      invalidSize: "O arquivo IFC deve ter menos de 2 GB.",
      duplicateName: "Já existe um modelo IFC com esse nome neste projeto.",
      actions: "Ações do modelo",
      download: "Baixar IFC",
      downloading: "Preparando download",
      downloadFailed: "Não foi possível baixar o modelo IFC.",
      edit: "Atualizar",
      delete: "Excluir modelo",
      replacing: "Enviando {{progress}}%",
      replacementStarted:
        "Modelo atualizado. O novo processamento da geometria foi iniciado.",
      replacementFailed: "Não foi possível atualizar o modelo IFC.",
      replacementNameMismatch:
        "Para atualizar este modelo, selecione um arquivo chamado {{name}}.",
      modelBusy:
        "Aguarde o processamento atual terminar antes de alterar o modelo.",
      deleteTitle: "Excluir modelo IFC?",
      deleteDescription:
        "{{name}} e todos os seus arquivos processados serão excluídos permanentemente.",
      deleteAction: "Excluir modelo",
      deleteSuccess: "Modelo IFC excluído.",
      deleteFailed: "Não foi possível excluir o modelo IFC.",
      processingStarted: "O processamento da geometria foi iniciado.",
      processingFailed:
        "Não foi possível iniciar o processamento da geometria.",
      failedDescription:
        "Não foi possível processar o modelo. Tente processá-lo novamente.",
      process: "Processar",
      updated: "Atualizado em {{date}}",
      emptyTitle: "Nenhum modelo IFC",
      emptyDescription: "Os modelos IFC do projeto aparecerão aqui.",
      status: {
        PENDING_UPLOAD: "Aguardando envio",
        UPLOADED: "Pronto para processar",
        QUEUED: "Na fila",
        PROCESSING: "Processando",
        COMPLETED: "Pronto",
        FAILED: "Falhou",
      },
      view: "Visualizar",
      generatingPreview: "Gerando prévia",
      thumbnailAlt: "Prévia de {{name}}",
      previewAlt: "Prévia ampliada de {{name}}",
      previewUnavailable: "Prévia indisponível",
      federation: {
        action: "Federar",
        onlyOneAllowed: "Apenas uma federação é permitida por projeto.",
        publish: "Publicar",
        modelPublished: "Modelo publicado na federação.",
        publishFailed: "Não foi possível publicar o modelo na federação.",
        badge: "Federação",
        selected: "{{count}} selecionados",
        clearSelection: "Limpar seleção de modelos",
        selectModel: "Selecionar {{name}}",
        confirmTitle: "Federar os modelos selecionados?",
        confirmDescription:
          "Os {{count}} modelos selecionados serão abertos juntos e não poderão mais ser visualizados ou excluídos individualmente.",
        created: "Federação criada. A prévia combinada está sendo gerada.",
        createFailed: "Não foi possível federar os modelos selecionados.",
        memberCount: "{{count}} modelos",
        generatingPreview: "Gerando prévia",
        processingModel: "Processando modelo atualizado",
        thumbnailAlt: "Prévia de {{name}}",
        removeMember: "Desfederar",
        memberRemoved: "Modelo desfederado.",
        memberRemoveFailed: "Não foi possível desfederar o modelo.",
        addModels: "Adicionar modelos",
        addModelsTitle: "Adicionar modelos à federação",
        addModelsDescription:
          "Selecione um ou mais modelos disponíveis para incluir em {{name}}.",
        noAvailableModels:
          "Não há modelos processados disponíveis para adicionar.",
        addSelected: "Adicionar {{count}} modelos",
        modelsAdded:
          "Modelos adicionados. A prévia combinada está sendo gerada novamente.",
        addModelsFailed: "Não foi possível adicionar os modelos selecionados.",
        dissolve: "Desfederar todos",
        dissolveTitle: "Desfederar todos os modelos?",
        dissolveDescription:
          "A federação será removida. Os modelos IFC e seus dados processados serão preservados.",
        dissolved: "Federação removida.",
        dissolveFailed: "Não foi possível remover a federação.",
      },
    },
  },
  viewer: {
    loading: {
      title: "Abrindo o visualizador",
      access: "Estamos validando seu acesso ao projeto e ao modelo IFC.",
      accessLabel: "Verificando projeto e modelo",
      locating:
        "O modelo está pronto. Estamos preparando um acesso seguro à geometria processada.",
      locatingLabel: "Localizando a geometria do modelo",
      downloadingTitle: "Baixando o modelo IFC",
      downloadingDescription:
        "Estamos baixando a geometria otimizada de {{fileName}}. Arquivos grandes podem levar alguns instantes.",
      modulesTitle: "Carregando as ferramentas 3D",
      modulesDescription:
        "Estamos carregando o mecanismo de visualização necessário para navegar pelo modelo.",
      modulesLabel: "Inicializando o ambiente 3D",
      preparingTitle: "Preparando o modelo",
      preparingDescription:
        "A geometria foi baixada. Agora estamos montando a cena e ajustando a câmera.",
      preparingLabel: "Renderizando modelo",
      tips: {
        rotate: "Arraste com o botão esquerdo para girar ao redor do modelo.",
        pan: "Arraste com o botão direito para se mover pelo modelo.",
        zoom: "Use a roda do mouse para aproximar em direção ao ponteiro.",
        select:
          "Selecione um elemento para acessar as ferramentas de visibilidade, isolamento e corte.",
      },
    },
    error: {
      title: "Não foi possível abrir o modelo",
      description:
        "O visualizador não conseguiu carregar este modelo agora. Volte à lista e tente novamente.",
      notReady:
        "Este modelo ainda não terminou de ser processado. Aguarde a conclusão antes de abri-lo.",
    },
    actions: {
      menu: "Ações do modelo",
      back: "Voltar aos modelos",
      reload: "Recarregar modelo",
      collapsePanels: "Recolher painéis laterais",
      expandPanels: "Expandir painéis laterais",
      openViewpoint: "Abrir vista salva no modelo",
      openViewpointError: "Não foi possível abrir a vista salva no modelo.",
    },
    tree: {
      title: "Árvore do modelo",
      geometryGroups: "{{count}} grupos de geometria",
      preparing: "Preparando geometria",
    },
    controls: {
      fit: "Enquadrar modelo",
      zoomIn: "Aproximar",
      zoomOut: "Afastar",
    },
    itemTools: {
      title: "Ferramentas do item",
      cutVertical: "Corte vertical",
      cutHorizontal: "Corte horizontal",
      hide: "Ocultar",
      hideAllExcept: "Ocultar todos exceto",
      showAll: "Mostrar todos",
      addIssue: "Adicionar apontamento",
      addIssueDisabled:
        "Apontamentos só podem ser adicionados na federação do projeto ou no primeiro modelo quando não há federação.",
    },
    issueForm: {
      title: "Adicionar apontamento",
      description: "A vista atual e o marcador serão salvos com o apontamento.",
      titlePlaceholder: "Título do apontamento",
      disciplinePlaceholder: "Selecione a disciplina",
      disciplineSearchPlaceholder: "Buscar disciplinas",
      disciplineSearchEmpty: "Nenhuma disciplina encontrada",
      priorityPlaceholder: "Selecione a prioridade",
      descriptionPlaceholder: "Descreva o apontamento",
      createDraft: "Criar como rascunho",
      createError: "Não foi possível criar o apontamento do visualizador.",
      fields: {
        title: "Título",
        discipline: "Disciplina",
        priority: "Prioridade",
        description: "Descrição",
        category: "Categoria",
        phase: "Fase",
        location: "Local",
        assignees: "Responsáveis",
        tags: "Tags",
      },
      sections: {
        organization: "Mais informações",
      },
    },
    issueDetails: {
      editTitle: "Editar apontamento #{{number}}",
      backToList: "Voltar aos apontamentos",
    },
    details: {
      title: "Detalhes do modelo",
      properties: "Propriedades",
      issues: "Apontamentos",
      issuesEmpty: "Nenhum apontamento no projeto",
      issuesDescription:
        "Apontamentos criados em qualquer modelo deste projeto aparecerão aqui.",
      issuesLoadError: "Não foi possível carregar os apontamentos do projeto.",
      issuesRetry: "Tentar novamente",
      issuesFilter: "Filtrar apontamentos",
      issuesFilterDiscipline: "Disciplina",
      issuesFilterAllDisciplines: "Todas as disciplinas",
      issuesFilterEmpty: "Nenhum apontamento corresponde a este filtro",
      issueCurrentResource: "Neste viewer",
      issueProject: "Projeto",
    },
    properties: {
      name: "Nome",
      size: "Tamanho do IFC",
      geometryGroups: "Grupos de geometria",
      triangles: "Triângulos",
      color: "Cor",
      selectedHint:
        "Clique em uma área vazia do modelo para voltar às propriedades gerais.",
      modelHint:
        "Selecione uma parte do modelo para inspecionar suas propriedades geométricas.",
    },
  },
  issues: {
    title: "Apontamentos",
    titlePlaceholder: "Dê um título ao apontamento",
    descriptionPlaceholder: "Descreva o problema",
    item: "Apontamento",
    create: "Novo apontamento",
    category: "Disciplina",
    dueDate: "Prazo",
    assignee: "Responsável",
    assignees: "Responsáveis",
    updatingIssue: "Atualizando apontamento",
    creatingIssue: "Criando apontamento",
    issueSubtitle: "Registre uma observação, pendência ou solicitação da obra.",
    issueNotFound: "Apontamento não encontrado.",
    issueCreated: "Apontamento criado!",
    issueUpdated: "Apontamento atualizado!",
    failIssueCreated: "Falha ao criar o apontamento.",
    failIssueUpdated: "Falha ao atualizar o apontamento.",
    invalidIssueForm: "Revise os campos inválidos antes de salvar.",
    draft: {
      label: "Rascunho",
      editing: "Editando rascunho",
      create: "Criar como draft",
      publish: "Publicar apontamento",
      moreOptions: "Mais opções de criação",
      created: "Rascunho criado!",
      updated: "Rascunho atualizado!",
      published: "Rascunho publicado!",
      failCreate: "Falha ao criar o rascunho.",
      failUpdate: "Falha ao atualizar o rascunho.",
      failPublish: "Falha ao publicar o rascunho.",
    },
    list: {
      filterText: "Filtrar apontamentos",
      tabs: {
        issues: "Apontamentos",
        drafts: "Rascunhos",
      },
      count: {
        issues: "apontamentos",
        drafts: "rascunhos",
      },
      untitledDraft: "Rascunho sem título",
      selectIssue: "Selecionar {{title}}",
      selection: {
        clear: "Limpar apontamentos selecionados",
        selectedOne: "selecionado",
        selectedMany: "selecionados",
        generateReport: "Gerar relatório em PDF",
        testAction: "Ação {{number}}",
        more: "Mais",
      },
      emptyTitle: "Apontamentos",
      emptyDescription: "Seus apontamentos aparecerão aqui.",
      emptyAction: "Crie seu primeiro apontamento",
      emptyDraftTitle: "Rascunhos",
      emptyDraftDescription: "Seus rascunhos aparecerão aqui.",
    },
    chat: {
      title: "Mensagens",
      open: "Abrir mensagens",
      close: "Fechar mensagens",
      pin: "Fixar mensagens",
      unpin: "Desafixar mensagens",
      unseenMessages: "Novas mensagens",
      placeholder: "Escreva uma mensagem...",
      send: "Enviar mensagem",
      addAttachment: "Adicionar anexo",
      addImage: "Adicionar imagem",
      addFile: "Adicionar arquivo",
      recordAudio: "Gravar áudio",
      delete: "Excluir mensagem",
      deleteConfirmationTitle: "Excluir mensagem?",
      deleteConfirmationDescription:
        "Esta mensagem será removida permanentemente.",
      messageActions: "Ações da mensagem",
      today: "Hoje",
      loadOlder: "Carregar mensagens anteriores",
      emptyTitle: "Nenhuma mensagem ainda",
      emptyDescription: "Inicie a conversa sobre este apontamento.",
      loadError: "Não foi possível carregar as mensagens.",
      sendError: "Não foi possível enviar a mensagem.",
      sending: "Enviando...",
      failed: "Não enviada",
      deleteError: "Não foi possível excluir a mensagem.",
      system: "Sistema",
    },
    orderBy: {
      newest: "Mais recente",
      oldest: "Mais antigo",
    },
    status: {
      open: "Aberto",
      checking: "Em análise",
      inProgress: "Em progresso",
      closed: "Resolvido",
      archived: "Arquivado",
    },
    board: {
      description:
        "Mova apontamentos entre as colunas para manter o status atualizado.",
      emptyLane: "Solte um apontamento aqui",
      tasks: "Tarefas",
    },
    priority: {
      low: "Baixa",
      moderate: "Média",
      high: "Alta",
      critical: "Crítica",
    },
    location: {
      storeyLabel: "Pavimento",
      areaLabel: "Local",
      empty: "Sem localização",
    },
    confirmArchive: {
      title: "Arquivar apontamento?",
      text: "Essa ação é irreversível. Depois de arquivado, este apontamento ficará permanentemente somente leitura e não poderá mais ser editado.",
      action: "Arquivar apontamento",
    },
    image: "Imagem do apontamento",
    validImages: "PNG, JPG ou WEBP.",
    archivedIssueWarning: "Apontamentos arquivados não podem ser modificados",
    attachmentLimitReached:
      "O limite de {{maxAttachments}} anexos foi atingido.",
  },
  jobs: {
    activeLabel: "Processos em andamento",
    statusLabel: "Status dos processos",
    dismiss: "Dispensar status do processo",
    processingDescription: "Você pode continuar trabalhando enquanto aguarda.",
    progress: {
      ariaLabel: "Progresso do processamento",
      count: "{{current}} de {{total}} elementos",
      finalizing: "Finalizando a geometria",
      thumbnail: "Gerando prévia do modelo",
      lessThanMinute: "Menos de um minuto restante",
      minutesRemaining: "Cerca de {{count}} min restantes",
      hoursRemaining: "Cerca de {{hours}}h {{minutes}}min restantes",
    },
    generic: {
      progressTitle: "Processando sua solicitação",
      readyTitle: "Seu processamento foi concluído",
      readyDescription: "O resultado está disponível.",
    },
    bcf: {
      progressTitle: "Importando seu BCF",
      readyTitle: "A importação do BCF foi concluída",
      readyDescription:
        "Os apontamentos importados estão prontos. Os detalhes aparecerão aqui quando a importação BCF for habilitada.",
    },
    report: {
      confirmTitle: "Gerar relatório dos apontamentos?",
      confirmDescription:
        "Um relatório em PDF será gerado com {{count}} apontamento(s) selecionado(s).",
      confirmAction: "Gerar relatório",
      createError: "Não foi possível iniciar o relatório. Tente novamente.",
      progressTitle: "Gerando seu relatório",
      progressDescription:
        "Os apontamentos selecionados estão sendo organizados em um relatório PDF.",
      readyTitle: "Seu relatório está pronto",
      readyDescription:
        "O PDF com {{count}} apontamento(s) está pronto para baixar.",
      download: "Baixar PDF",
      downloadError: "Não foi possível gerar o link. Tente novamente.",
    },
    ifc: {
      progressTitle: "Processando seu modelo IFC",
      progressDescription:
        "A geometria do modelo está sendo preparada. Você pode continuar trabalhando enquanto aguarda.",
      thumbnailDescription:
        "A geometria está pronta. Agora estamos gerando as prévias do modelo.",
      readyTitle: "Seu modelo IFC está pronto",
      readyDescription:
        "A geometria de {{count}} elemento(s) foi processada com sucesso.",
      readyWithPreviewWarning:
        "O modelo está pronto, mas não foi possível gerar sua prévia. Você ainda pode abri-lo normalmente.",
    },
    federationThumbnail: {
      progressTitle: "Gerando a prévia da federação",
      progressDescription:
        "A federação já pode ser aberta enquanto renderizamos sua prévia combinada.",
      readyTitle: "Prévia da federação pronta",
      readyDescription: "A prévia combinada dos modelos está disponível.",
    },
    details: {
      loading: "Carregando detalhes do processo...",
      loadErrorTitle: "Processo não encontrado",
      loadErrorDescription:
        "O processo pode não estar mais disponível ou você pode não ter acesso a ele.",
      failedTitle: "O processo não foi concluído",
      failedDescription: "Tente iniciá-lo novamente.",
    },
  },
};
